import React from "react";

import { BaseProcedureType } from "@graffer-inc/cloud-gov-core";
import { PrimaryButton, WarningDialog } from "@graffer-inc/console-design-kit";

import { Organization } from "../../../../application/domain/organization/organization";

export type Props = {
  tenant?: Organization;
  selectedProcedure?: BaseProcedureType;
  kintoneAppUrl: string;

  isLoading: boolean;
  showDialog: boolean;
  showValidationErrorMessage: boolean;
  showKintoneApiErrorMessage: boolean;
  showNoEmailUserInGroupErrorMessage: boolean;

  onClickCreateOnPage: () => void;
  onClickCreateOnDialog: () => void;
  onClickCancelOnDialog: () => void;
};

export const Buttons: React.FC<Props> = ({
  tenant,
  selectedProcedure,
  kintoneAppUrl,
  isLoading,
  showDialog,
  showValidationErrorMessage,
  showKintoneApiErrorMessage,
  showNoEmailUserInGroupErrorMessage,
  onClickCreateOnPage,
  onClickCreateOnDialog,
  onClickCancelOnDialog,
}) => {
  return (
    <>
      {showValidationErrorMessage && (
        <div className="columns is-vcentered mb-5">
          <div className="column">
            <div className="notification is-danger is-light">
              入力内容にエラーがあります。
            </div>
          </div>
        </div>
      )}
      {showKintoneApiErrorMessage && (
        <div className="columns is-vcentered mb-5">
          <div className="column">
            <div className="notification is-danger is-light">
              <div className="content">
                <p>
                  kintone
                  への疎通に失敗したため、連携設定を作成できませんでした。次の内容を確認してください。
                </p>
                <ul>
                  <li>
                    入力した kintone アプリ ID と API
                    トークンの組み合わせは正しいですか？
                  </li>
                  <li>
                    API トークンに権限が付与された状態で kintone
                    アプリを保存・公開していますか？
                  </li>
                  <li>
                    kintone に対して IP
                    アドレス制限が設定されていませんか？設定されている場合、グラファーのサーバーを許可する必要があります。
                  </li>
                  <li>
                    kintone
                    に対してベーシック認証が設定されていませんか？現状、当機能はベーシック認証に対応していません。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      {showNoEmailUserInGroupErrorMessage && (
        <div className="columns is-vcentered mb-5">
          <div className="column">
            <div className="notification is-danger is-light">
              選択されたスマート申請手続きの管理グループにメールアドレスを持つユーザーが存在しません。
            </div>
          </div>
        </div>
      )}
      <div className="columns is-vcentered">
        <div className="column has-text-right">
          <PrimaryButton
            text="作成"
            onClick={onClickCreateOnPage}
            disabled={isLoading}
          />
        </div>
      </div>
      {showDialog && (
        <WarningDialog
          title="設定が正しいことを確認してください"
          contents={
            <div>
              <p>
                {/* 事実上、 ServiceProviderAccount (tenant が truthy の場合) vs Tenant User の挙動調整。 */}
                {`${tenant ? "テナントが受け付けた" : ""}申請データを外部システムへ転送する設定です。`}
              </p>
              <p>
                作成する前に、意図した設定となっているかを改めて確認してください。
              </p>
              <br />
              {!!tenant && (
                <p>
                  テナント名:{" "}
                  <span className="has-text-weight-bold">{tenant?.name}</span>
                </p>
              )}
              <p>
                手続き名:{" "}
                <span className="has-text-weight-bold">
                  {selectedProcedure?.name}
                </span>
              </p>
              <p>
                kintone アプリ URL:{" "}
                <span className="has-text-weight-bold">{kintoneAppUrl}</span>
              </p>
            </div>
          }
          cancelText="キャンセル"
          proceedText="このまま作成"
          onCancel={onClickCancelOnDialog}
          onProceed={onClickCreateOnDialog}
        />
      )}
    </>
  );
};
